module.exports = __webpack_public_path__ + "media/images/riders/small/TANJA_ZAKEIJ-355544c9d6abc239486dd58595e836b0.png";